'use strict';

var validators = require('./validators');
var selectValuesValid = require('./select-values-valid');

var nestedValidators = {
  selectValuesValid: selectValuesValid
};

var ValueValidationError = require('./models/value-validation-error');

module.exports = function validateRulesForValue(validationOptions, value, fieldKey, failureKey) {
  var rules = validationOptions.rules || [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = rules.filter(function (r) {
      return r !== 'required';
    })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var ruleKey = _step.value;

      var validator = validators[ruleKey] || nestedValidators[ruleKey];

      if (!validator) {
        throw new Error('Validator with key ' + ruleKey + ' was not found');
      }

      var validationResult = validator(value, validationOptions);

      if (!validationResult.isValid) {
        return [new ValueValidationError(fieldKey, failureKey, validationResult.failureMessages)];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return [];
};